import { createApp } from "vue";
import App from "./App.vue";
import { createAppI18n } from "./i18n";
import "./style.css";

async function main() {
  const mock = import.meta.env.DEV && import.meta.env.MODE === "mock";
  const services = mock
    ? (await import("./dev/mockServices")).createMockServices()
    : (await import("./services")).createServices();
  createApp(App, { services, mock }).use(createAppI18n()).mount("#app");
}

void main();
